<template>
   <div class="payment-history bg-red">
        <div class="payment-iocn payment-rejected">
            <img src="@/assets/images/payment-rejected.svg" alt="payment-rejected" loading="lazy">
        </div>
        <div class="request_title">
            <h3>{{ walletDetails?.user_name }}</h3>
            <p>{{ walletDetails?.type==2 ? $t('deposit', 'Deposit') : $t('withdraw', 'Withdraw')}} {{$t('request-rejected', 'Request Rejected')}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "DepositRequestRejected",
    props:['walletDetails'],
}
</script>

<style scoped>
    .payment-history.bg-red {
        background: red;
    }
</style>